<template>
  <div
    class="m-dropdown-content m-dropdown-content-right"
    id="MoleculeTheHeaderSubMenuDropDownUser"
  >
    <header class="m-dropdown-header width-150-px">
      <span class="ellipsis m-dropdown-title text-color-academy-primary">
        {{ nombre }}
      </span>
      <span class="ellipsis m-dropdown-subtitle">
        {{ email }}
      </span>
    </header>
    <section class="m-dropdown-section">
      <ul class="m-dropdown-list">
        <li>
          <router-link
            :to="`/${$t('rPaths.account')}/${$t('mEditionMenu.account.profile.subject')}`"
            @click.native="$dropDown.closeDropDown('MoleculeTheHeaderSubMenuDropDownUser')"
          >
            <span class="m-dropdown-item-icon">
              <i class="far fa-smile text-color-academy-primary"></i>
            </span>
            <span class="m-dropdown-item-text">
              {{ $t('mTheHeaderSubMenuDropDownUser.options.account') }}
            </span>
          </router-link>
        </li>
        <li>
          <router-link
            :to="`/${$t('rPaths.account')}/${$t('mEditionMenu.account.security.subject')}`"
            @click.native="$dropDown.closeDropDown('MoleculeTheHeaderSubMenuDropDownUser')"
          >
            <span class="m-dropdown-item-icon">
              <i class="far fa-lock-alt text-color-academy-primary"></i>
            </span>
            <span class="m-dropdown-item-text">
              {{ $t('mTheHeaderSubMenuDropDownUser.options.security') }}
            </span>
          </router-link>
        </li>
        <li>
          <router-link
            :to="`/${$t('rPaths.billing')}/${$t('mEditionMenu.billing.myShopping.subject')}`"
            @click.native="$dropDown.closeDropDown('MoleculeTheHeaderSubMenuDropDownUser')"
          >
            <span class="m-dropdown-item-icon">
              <i :class="['far fa-file-invoice-dollar', academyDataColor
                ? 'text-color-academy-primary'
                : 'text-color-billing-primary']"
              ></i>
            </span>
            <span class="m-dropdown-item-text">
              {{ $t('mTheHeaderSubMenuDropDownUser.options.shopping') }}
            </span>
          </router-link>
        </li>
        <li>
          <router-link
            to="/logout"
          >
            <span class="m-dropdown-item-icon">
              <i class="far fa-arrow-alt-right text-color-danger"></i>
            </span>
            <span class="m-dropdown-item-text">
              {{ $t('mTheHeaderSubMenuDropDownUser.options.logout') }}
            </span>
          </router-link>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'MoleculeTheHeaderSubMenuDropDownUser',

  props: {
    usuario: Object
  },

  computed: {
    academyDataColor () {
      return this.$store.getters.getAcademyData.color
    },

    email () {
      return this.usuario.email
    },

    nombre () {
      return this.usuario.vidroop_data &&
        this.usuario.vidroop_data.persona &&
        this.usuario.vidroop_data.persona.razon_social
        ? this.usuario.vidroop_data.persona.razon_social
        : this.usuario.email
    }
  }
}
</script>
